import { render, staticRenderFns } from "./BouncePopup.vue?vue&type=template&id=0c63d1a6&"
import script from "./BouncePopup.vue?vue&type=script&lang=js&"
export * from "./BouncePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports